import React from 'react';

import { LoadingSpinner, Size, Type } from './components/LoadingSpinner';

type Props = {
  /**
   * The percent to show on the loading bar. Uses a spinner if omitted
   */
  percent?: number;
  size?: Size;
  className?: string;
  type?: Type;
};

export const Loading = ({ percent, size, className, type }: Props) => {
  if (percent) {
    // Eventually this should present a loading bar
    throw new Error('Not yet implemented');
  }

  return <LoadingSpinner size={size} className={className} type={type} />;
};
